import ErrorIcon from '@mui/icons-material/Error'
import Tooltip from '@mui/material/Tooltip'

import type { EntityKpi as EntityKpiType } from '@models/EntityKpi'

interface Props {
  kpi?: EntityKpiType
}

export const EntityKpi = ({ kpi }: Props) => {
  if (!kpi || kpi.ragLabel === 'green') {
    return null
  }

  const color = kpi.ragLabel === 'red' ? 'red' : 'darkorange'

  return (
    <Tooltip title={kpi.msg}>
      <ErrorIcon sx={{ color }} />
    </Tooltip>
  )
}
